import React from 'react';
import styled from 'styled-components';
import {NO_TEAM} from './translationValues.js';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['NO_TEAM'];

const LoaderContainer = styled.div`
  margin-bottom: 30px;
`;

const NoTeam = props => {
  const { type = 'template' } = props;
  const { t } = useTranslation(NAMESPACES);
  return (
    <LoaderContainer>
      <h4>
        {t(NO_TEAM.TEAMS_NOT_AVAILABLE_DESC.key,NO_TEAM.TEAMS_NOT_AVAILABLE_DESC.value,{ type: type })}
      </h4>
    </LoaderContainer>
  );
};
export default NoTeam;
